import React from 'react'
import { LiaFileSolid } from "react-icons/lia";
import { MdFileDownloadDone } from "react-icons/md";
import { RxCrossCircled } from "react-icons/rx";

const UploadFileSkull = ({ file, fileProcces, isInQueue,deleteFiles  }) => {

    return (
        <div style={{
            height: 80,
            width: "100%",
            backgroundColor: "#f4f6f8",
            display: "flex",
            marginBottom: 8,
            borderRadius: 10,
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
        }}>
            <div style={{
                width: 70,
                height: "100%",
                backgroundColor: "#4a90e2",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                borderTopLeftRadius: 10,
                borderBottomLeftRadius: 10
            }}>
                <LiaFileSolid size={32} color='white' />
                <p style={{ color: "white", margin: 0, fontSize: 12 }}>{file.name.split(".")[1].toUpperCase()}</p>
            </div>
            <div style={{
                backgroundColor: "#ffffff",
                flex: 1,
                padding: 10,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                borderTopRightRadius: 10,
                borderBottomRightRadius: 10
            }}>
                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 8
                }}>
                    <p style={{ margin: 0, fontWeight: 500, color: "#333" }}>{file.name.length > 20 ? file.name.slice(0, 24) + "..." : file.name}</p>
                    {fileProcces?.percent === 100 && <MdFileDownloadDone color="#4caf50" size={20} /> }
                    {!isInQueue && <RxCrossCircled onClick={()=>deleteFiles()} color='red' size={20} cursor={"pointer"}/>}
                </div>
                <div style={{
                    height: 10,
                    width: "100%",
                    backgroundColor: "#e0e0e0",
                    overflow: "hidden",
                    borderRadius: 4,
                    marginBottom: 5
                }}>
                    <div style={{
                        height: "100%",
                        width: fileProcces ? fileProcces.percent + "%" : "0%",
                        backgroundColor: "#4caf50"
                    }}></div>
                </div>
                <p style={{ textAlign: "right", }}>{fileProcces ? `${fileProcces.percent === 100 ? "Uploaded" : 'Uploading'} ${fileProcces.percent} %` : isInQueue ? "Queue" : ""}</p>
            </div>
        </div>
    )
}

export default UploadFileSkull;
